import React, { useState, useEffect } from 'react';
import Card from './Card/Card';
import FeaturedBlog from './FeaturedBlog/FeaturedBlog';
import SearchBar from './SearchBar/SearchBar';
import Tabs from './Tabs/Tabs';
import CategoryFilter from './CategoryFilter/CategoryFilter';
import AdComponent from './AdComponent/AdComponent';
import './BlogPage.css';
import MobileFilterSort from './MobileFilterSort/MobileFilterSort';
import {fetchBlogPosts, getFeaturedBlogPost, fetchAllCategories, getCategoriesArray, fetchAdComponent} from '../../services/blog/postServices';
import { fetchPageMetaData } from '../../services/metaService';
import { useNavigate } from 'react-router-dom';

const BlogPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTab, setSelectedTab] = useState('Latest');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [visibleCount, setVisibleCount] = useState(6);
  const [blogPosts, setBlogPosts] = useState([]);
  const [featuredBlog, setFeaturedBlog] = useState(null);
  const [categories,setCategories]=useState([]);
  const [metaData,setMetaData]=useState({});
  const [isLoading, setIsLoading] = useState(true); 
  const [adComponent,setAdComponent]=useState({});
  const navigate=useNavigate();
 
  useEffect(()=>{
    const MetaData=async()=>{
        const data=await fetchPageMetaData('Blog');
        setMetaData(data[0]);
    }
    const loadAdComponent=async()=>{
      const data=await fetchAdComponent('blog-ad-component');
      setAdComponent(data[0]);
    }
    MetaData();
    loadAdComponent();
    
    
  },[])
  
  useEffect(()=>{
    if (metaData){
      document.title=metaData.metaTitle || "Tripta Innovations Private Limited Blog Page"
      // Meta description
      const metaDescription=document.querySelector('meta[name="description"]');
      if (metaDescription){
        metaDescription.setAttribute("content",metaData.metaDescription || "Default Description");
      }else {
        const description = document.createElement("meta");
        description.name = "description";
        description.content = metaData.metaDescription || "Default Description";
        document.head.appendChild(description);
      }
      // Meta Image
      const metaImage=document.querySelector('meta[property="og:image"]');
      if (metaImage){
        metaImage.setAttribute("content",`${process.env.REACT_APP_STRAPI_API_BASE_URL}${metaData.metaImage?.url}` || "Default Image URL");
      }else{
        const image=document.createElement("meta");
        image.setAttribute("property","og:image");
        image.setAttribute("content",`${process.env.REACT_APP_STRAPI_API_BASE_URL}${metaData.metaImage?.url}` || "Default Image URL");
        
        document.head.appendChild(image);
      }

      // Canonical URL
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      
      if (canonicalLink) {
        canonicalLink.setAttribute("href", metaData.canonicalUrl || window.location.href);
      } else {
        const link = document.createElement("link");
        link.rel = "canonical";
        link.href =metaData.canonicalUrl || window.location.href;
        document.head.appendChild(link);
      }
      
    }
  },[metaData])
  
 
  
  
  
  // Fetch the categories of the blog
  useEffect(()=>{
    const loadCategories=async()=>{
      const Categories=await fetchAllCategories();
      setCategories(getCategoriesArray(Categories));
      
 
    }
    loadCategories();
  },[])
  
  
  
  
  // Fetch blog posts and featured blog
  useEffect(() => {
    const fetchData = async () => {
      try {
        const posts = await fetchBlogPosts();
        const featured = await getFeaturedBlogPost();
        setBlogPosts(posts);
        setFeaturedBlog(featured);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally{
        setIsLoading(false);
      }
      
    };
    fetchData();
  }, []);

  const filteredCards = blogPosts
    .filter(card =>
      card.Title.toLowerCase().includes(searchQuery.toLowerCase()) &&
      (!selectedCategory || card.Category.Name === selectedCategory) 
    )
    .sort((a, b) => selectedTab === 'Latest' ? new Date(b.Date) - new Date(a.Date) : 0);

  const lastThreeCards = selectedTab === 'Latest'
    ? filteredCards.slice(-3)
    : [];

  const sidebarTitles = selectedTab === 'Trending'
    ? blogPosts.sort((a, b) => b.Views - a.Views).slice(0, 3)
    : lastThreeCards;
  
  const handleShowMore = () => {
    setVisibleCount(prevCount => prevCount + 6);
  };

  const handleSearch = () => {
    console.log('Search triggered:', searchQuery);
  };
  if (isLoading){
    return (
      <div className="loader-container">
        <div className="fading-bars">
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
    );
  }
  return (
    <div className='blog-container'>
      <div className="blog-search-container">
        <SearchBar
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onSearch={handleSearch}
        />
      </div>

      <div className="blog-page">
        <div className='mobile-view-filter'>
          <MobileFilterSort 
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            categories={categories}
          />
        </div>
        <div className="blog-sidebar">
          <Tabs selectedTab={selectedTab} onSelectTab={setSelectedTab} />
          {(selectedTab === 'Latest' || selectedTab === 'Trending') && (
            <div className="blog-sidebar-titles">
              <ul>
                {sidebarTitles.map((card, index) => (
                  <li 
                    key={index} 
                    className="blog-sidebar-title"
                    onClick={()=>navigate(`/blog/${card.documentId}`)}
                  >
                    {card.Title.length > 50 ? `${card.Title.slice(0, 50)}...` : card.Title}
                  </li>
                ))}
              </ul>
            </div>
          )}
          <CategoryFilter
            categories={categories}
            selectedCategory={selectedCategory}
            onSelectCategory={setSelectedCategory}
          />
          <AdComponent imageUrl={`${process.env.REACT_APP_STRAPI_API_BASE_URL}${adComponent.AdImage?.url}`} link={adComponent.URL} />
        </div>

        <div className="blog-main-content">
          {/* Featured Blog */}
          {featuredBlog && (
            <FeaturedBlog
              id={featuredBlog.documentId}
              imageSrc={`${process.env.REACT_APP_STRAPI_API_BASE_URL}${featuredBlog.Img.url}`}
              category={featuredBlog.Category.Name}
              title={featuredBlog.Title}
              date={featuredBlog.Date}
            />
          )}

          {/* Blog Cards Section */}
          <div className="blog-card-list">
            {filteredCards.slice(0, visibleCount).map((card) => (
              
              <Card
                key={card.documentId}
                id={card.documentId}
                imageSrc={`${process.env.REACT_APP_STRAPI_API_BASE_URL}${card.Img.url}`}
                category={card.Category.Name}
                title={card.Title}
                date={card.Date}
                content={card.Content}
                subheadings={card.subheadings}
              />
            ))}
          </div>

          {/* Show More Button */}
          {filteredCards.length > visibleCount && (
            <div className="blog-button-container">
              <button onClick={handleShowMore}>Show More</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
